module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M17.85 9.753l-7.062 6.976c-.394.39-.291.864.195 1.131a7.438 7.438 0 0 1 2.912 2.932c.265.486.738.591 1.129.197 1.963-1.988 4.377-4.429 6.99-7.076C28.594 7.255 32.693 1.29 31.586.179 30.473-.928 24.508 3.171 17.85 9.753zM7.472 19.944c-1.988 0-3.834 1.409-4.299 3.354-.527 2.054-1.162 5.078-2.787 7.357-.703.987-.44 1.495.717 1.304 3.615-.593 10.716-3.396 10.716-7.544 0 0 0 .376 0 0 .002-2.47-2.004-4.472-4.347-4.472z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/brush-1.js
// module id = 1028
// module chunks = 14